import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { UserDao } from '@app/dao/user/user.dao';
import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface';
import { combineLatest, Observable, map } from 'rxjs';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  DialogData,
  SubscriptionFacadeService,
} from '../../services/subscription-facade.service';

type OptionType = Array<{ ids: any; label: string }>;
@UntilDestroy()
@Component({
    selector: 'dialog-owners-overview',
    templateUrl: './dialog-owners-overview.component.html',
    styleUrls: ['./dialog-owners-overview.component.scss'],
    standalone: false
})
export class DialogOwnersOverviewComponent implements OnInit {
  @ViewChild('list', { static: true }) list: MatSelectionList;
  options2: string[] = [
    'Je souscris seul',
    'Conjoint souscrit seul',
    'Nous souscrivons à 2',
    'Enfants',
  ];

  multiple: boolean = true;
  options: OptionType = [];
  owner$: Observable<OptionType>;

  constructor(
    public dialogRef: MatDialogRef<DialogOwnersOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public userDao: UserDao,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {}
  ngOnInit() {
    this.owner$ = combineLatest([
      this.userDao.getCouple(),
      this.userDao.getOwners(),
    ]).pipe(
      map(([couple, owners]) => {
        let leftowners = [...owners];
        for (let user of couple) {
          let owner = leftowners.find(o => o.id == user.id);
          leftowners = leftowners.filter(o => o !== owner);
          this.options.push({
            ids: this.multiple ? [owner.id] : owner.id,
            label: owner.label,
          });
        }
        if (couple.length > 1 && this.multiple === true) {
          if (this.data.productType !== ProductsTypeEnum.ASSURANCE_VIE) {
            let ids = couple.map(user => user.id);
            this.options.push({ ids: ids, label: 'En commun' });
          }
        }
        for (let owner of leftowners) {
          this.options.push({
            ids: this.multiple ? [owner.id] : owner.id,
            label: owner.label,
          });
        }
        return this.options;
      }),
    );
  }

  onClick(): void {
    this.data.mode === 'edit' ? this.initOwner() : this.createPledge();
  }

  initOwner() {
    const pledge = this.data.pledge;
    const ids = this.list.selectedOptions.selected.map(o => o.value);
    this.subscriptionFacade.emitPledgeAndEntity(pledge);
    this.subscriptionFacade.navigateTo(pledge.productType, pledge.id, ids);

    this.dialogRef.close();
  }
  createPledge() {
    const ids = this.list.selectedOptions.selected.map(o => o.value);
    const params = {
      productType: this.data.productType,
      productName: 'Euodia Vie',
      ownerIds: this.list.selectedOptions.selected.map(o => o.value)[0],
      productIds: undefined,
      physicalUser: true,
      operation: 'SUBSCRIPTION',
    };
    this.subscriptionFacade
      .initPledge(params)
      .pipe(untilDestroyed(this))
      .subscribe(pledge => {
        this.data?.productType &&
          this.subscriptionFacade.navigateTo(
            this.data.productType,
            pledge.id,
            ids,
          );
      });
    this.dialogRef.close();
  }
}
